export default __webpack_public_path__ + "static/media/eye.ad0eb181.svg";